// 'auto' — следовать системной теме (prefers-color-scheme); дефолт для новых
// пользователей. У выбравших тему вручную сохранённое значение не меняется.
export const APP_THEMES = ['auto', 'dark', 'sepia', 'light'];
// Ступени размера текста. Множители продублированы в global.css
// (:root[data-font-scale='…'] → --font-scale) — менять надо оба места.
export const APP_FONT_SCALE_STEPS = [
  { value: 'small', factor: 0.875 },
  { value: 'default', factor: 1 },
  { value: 'large', factor: 1.125 },
  { value: 'xlarge', factor: 1.25 },
  { value: 'xxlarge', factor: 1.4 },
];
export const APP_FONT_SCALES = APP_FONT_SCALE_STEPS.map((step) => step.value);

export function getFontScaleFactor(value) {
  const step = APP_FONT_SCALE_STEPS.find((item) => item.value === value);
  return step ? step.factor : 1;
}

// Потолок ДЛИНЫ ОТВЕТА модели (не контекстное окно): продублирован на бэкенде
// (config.py: default_max_tokens, max_tokens_limit, max_output_tokens_cap) —
// менять надо оба места. 128000 — максимум, который принимают модели каталога.
export const MAX_TOKENS_LIMIT = 128000;

export const DEFAULT_APP_SETTINGS = {
  displayName: null,
  avatarDataUrl: null,
  theme: 'auto',
  fontScale: 'default',
  soundEnabled: true,
  sendSoundEnabled: true,
  responseSoundEnabled: true,
  browserNotificationsEnabled: false,
  defaultModel: null, // резолвится с бэка (/api/settings/app); до загрузки — defaultModelStore
  temperature: 0.7,
  maxTokens: MAX_TOKENS_LIMIT,
};

function normalizeNumber(value, fallback, min, max) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric < min || numeric > max) {
    return fallback;
  }
  return numeric;
}

export function normalizeAppSettings(settings = {}) {
  return {
    ...DEFAULT_APP_SETTINGS,
    ...settings,
    theme: APP_THEMES.includes(settings.theme) ? settings.theme : DEFAULT_APP_SETTINGS.theme,
    fontScale: APP_FONT_SCALES.includes(settings.fontScale) ? settings.fontScale : DEFAULT_APP_SETTINGS.fontScale,
    defaultModel: typeof settings.defaultModel === 'string' && settings.defaultModel.trim()
      ? settings.defaultModel.trim()
      : DEFAULT_APP_SETTINGS.defaultModel,
    temperature: normalizeNumber(settings.temperature, DEFAULT_APP_SETTINGS.temperature, 0, 2),
    maxTokens: Math.trunc(normalizeNumber(settings.maxTokens, DEFAULT_APP_SETTINGS.maxTokens, 1, MAX_TOKENS_LIMIT)),
  };
}

// Фон статус-бара iOS (meta theme-color) = --bg-secondary соответствующей темы.
const THEME_COLORS = { dark: '#1a1a2e', light: '#fffdf8', sepia: '#f8f0e0' };

function updateThemeColorMeta(resolvedTheme) {
  if (typeof document === 'undefined') {
    return;
  }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta && THEME_COLORS[resolvedTheme]) {
    meta.setAttribute('content', THEME_COLORS[resolvedTheme]);
  }
}

function systemPrefersLight() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-color-scheme: light)').matches;
}

// Подписка на смену системной темы — активна только при theme='auto'.
let systemThemeMedia = null;
let systemThemeHandler = null;

function unbindSystemTheme() {
  if (systemThemeMedia && systemThemeHandler) {
    systemThemeMedia.removeEventListener('change', systemThemeHandler);
  }
  systemThemeMedia = null;
  systemThemeHandler = null;
}

export function applyAppSettingsToDocument(settings, target = typeof document !== 'undefined' ? document.documentElement : null) {
  if (!target) {
    return;
  }

  const normalized = normalizeAppSettings(settings);
  const resolvedTheme = normalized.theme === 'auto'
    ? (systemPrefersLight() ? 'light' : 'dark')
    : normalized.theme;
  target.dataset.theme = resolvedTheme;
  target.dataset.fontScale = normalized.fontScale;
  updateThemeColorMeta(resolvedTheme);

  unbindSystemTheme();
  if (normalized.theme === 'auto' && typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    systemThemeMedia = window.matchMedia('(prefers-color-scheme: light)');
    systemThemeHandler = () => {
      const next = systemThemeMedia.matches ? 'light' : 'dark';
      target.dataset.theme = next;
      updateThemeColorMeta(next);
    };
    systemThemeMedia.addEventListener('change', systemThemeHandler);
  }
}

export function getDisplayNameFallback(settings, userId) {
  const displayName = settings?.displayName?.trim();
  if (displayName) {
    return displayName;
  }
  return userId || 'Пользователь';
}
